import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";

import review1 from "../../assets/images/review/review1.jpg";
import review2 from "../../assets/images/review/review2.jpg";
import review3 from "../../assets/images/review/review3.jpg";
import star from "../../assets/images/icons/star.png";
import "./Reviews.css";

// import "swiper/css/pagination";
// import 'swiper/css/scrollbar';
// import 'swiper/css/navigation';
// import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
// import required modules

const Reviews = () => {
  const reviewsArr = [
    {
      writerName: "יובל לוי",
      date: "11 מאי 2022",
      rating: "5.0",
      text: "עבדו באופן מקצועי ושמרו על הרהיטים",
      img: review1,
    },
    {
      writerName: "ניסים בוסקילה",
      date: "7 מאי 2022",
      rating: "4.0",
      text: "חוויה משנת חיים",
      img: review2,
    },
    {
      writerName: "יונתן ספקטור",
      date: "1 מאי 2022",
      rating: "5.0",
      text: "עבדו באופן מקצועי ושמרו על הרהיטים",
      img: review3,
    },
    {
      writerName: "יזהר לוי",
      date: "1 מאי 2022",
      rating: "5.0",
      text: "התבלבלו ביני ובין אחי התאום",
      img: review1,
    },
  ];

  const slides = reviewsArr.map((el, i) => (
    <div className="review" key={i}>
      <div className="stars">
        <img src={star} alt="" />
        <img src={star} alt="" />
        <img src={star} alt="" />
        <img src={star} alt="" />
        <img src={star} alt="" />
      </div>
      <p className="reviewText">{el.text}</p>
      <div className="reviewer">
        <img src={el.img} alt="" />
        <div className="reviewerDetails">
          <h1 className="name">{el.writerName}</h1>
          <p className="date">{el.date}</p>
        </div>
      </div>
    </div>
  ));

  return (
    <div className="reviewsDiv">
      <h1 className="homeTitle">ביקורות</h1>
      <div className="reviews">
        <Swiper
          // modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={10}
          // navigation
          // pagination={{ clickable: true }}
          // scrollbar={{ draggable: true }}
          // centeredSlides={true}
          modules={[Autoplay]}
          slidesPerView={1}
          breakpoints={{
            600: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            900: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
        >
          {slides.map((slideContent, index) => (
            <SwiperSlide key={index} virtualIndex={index}>
              {slideContent}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Reviews;
